function About({color, title, paragraphs}){
    return (
        <div
            className="px-4 py-3 my-4 text-center container-wide box-shadow"
            id="about"
        >
            <h1 className={`display-5 fw-bold text-body-emphasis quint ${color}`}>
                {title}
            </h1>
            <div className="col-lg-10 mx-auto">
                {paragraphs.map((p,i) => <p key={i} className="mb-0">{p}</p>)}
            </div>
        </div>
    );
}

export default About;